module.exports = __webpack_public_path__ + "img/check-filled.b3956bed.svg";